import styled from 'styled-components'

import { Item } from './Item'

type Props = {
	isHighlighted: boolean
	isSelected: boolean
	isDisabled: boolean
}

export const ItemContent = styled.div<Props>`
	background-color: ${({ isHighlighted, isDisabled, isSelected, theme }) => {
		if (isHighlighted)
			return isDisabled
				? theme.color.input.menuOptionBackgroundHighlightedDisabled
				: theme.color.input.menuOptionBackgroundHighlighted
		if (isSelected)
			return isDisabled
				? theme.color.input.menuOptionBackgroundSelectedDisabled
				: theme.color.input.menuOptionBackgroundSelected
		return isDisabled ? theme.color.input.menuOptionBackgroundDisabled : theme.color.input.menuOptionBackground
	}};
	display: flex;
	padding: 8px 10px;
	border-radius: 4px;
	transition: background-color 80ms ease;
	align-items: center;
	justify-content: space-between;
	column-gap: 6px;

	${Item}:hover {
		background-color: ${({ theme, isDisabled }) => (isDisabled ? theme.color.input.menuOptionBackgroundHoverDisabled : theme.color.input.menuOptionBackgroundHover)};
	}
`
